import Vue from 'vue'
// import VueLazyload from 'vue-lazyload'
import App from './App.vue'
import router from './router'
import store from './store'
// import BaiduMap from 'vue-baidu-map' // 导入地图
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/rem/rem.js'
import 'wowjs/css/libs/animate.css'

// 进行全局注册，一次性引入百度地图组件库的所有组件
// ak为官方提供的密钥
// Vue.use(BaiduMap, {
//   ak: 'K4ReQsyVBz7d5edz5iGR7t59gyZuR7U7'
// })
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   loading: require('@/assets/images/loading.gif'),
//   attempt: 1
// })
Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
